import type { FC } from "react"

import { formatNumber, roundToPrecision } from "@/utils/number"

interface AdjustmentQuantityDiffProps {
  quantity: number
  originalQuantity: number
  uomName: string
  "data-testid"?: string
}

export const AdjustmentQuantityDiff: FC<AdjustmentQuantityDiffProps> = ({
  quantity,
  originalQuantity,
  uomName,
  "data-testid": testId,
}) => {
  const value = roundToPrecision(quantity - originalQuantity, 2)

  if (!value) return null

  return (
    <span className={value < 0 ? "text-secondary-600" : "text-tertiary-green-900"} data-testid={testId}>
      {value > 0 ? "+" : ""}
      {formatNumber(value)} {uomName}
    </span>
  )
}
